import React, { useCallback } from 'react';
import translate from '../../utilities/translator';
// import Switch from './../../components/Switch';
// import { useDispatch, useSelector } from 'react-redux';
// import { selectLocationDealsList, setHideSoldOutDeals } from './locationDealsSlice';

export default function SoldOutAlert() {
  /* const dispatch = useDispatch();
  const { hideSoldOutDeals } = useSelector(selectLocationDealsList);

  const handleHideSoldOutDealsClick = useCallback(() => {
    dispatch(setHideSoldOutDeals(!hideSoldOutDeals));
  }, [dispatch, hideSoldOutDeals]); */

  return (
    <div className="c-row">
      <div className="col-lg-12">
        <div className="sold-out-panel">
          <div className="content__wrap">
            <div className="icon">
              <i className="ri-lightbulb-line" />
            </div>
            <div className="content">
              <b>{translate('holidayFinder.alerts.soldOut_title')}</b>
              <br />
              <span>{translate('holidayFinder.alerts.soldOut_message')}</span>
            </div>
          </div>
          {/* This is switch is hidden on request */}
          {/* <div className="hide-sold-btn">
            {translate('holidayFinder.alerts.soldOut_button')}
            <Switch onChange={handleHideSoldOutDealsClick} value={hideSoldOutDeals} />
          </div> */}
        </div>
      </div>
    </div>
  );
}
